import React from 'react'
import ReactPanZoom from 'react-image-pan-zoom-rotate'

import { FaPrint } from 'react-icons/fa'

import Mask from './mask'
import { BiPrinter } from 'react-icons/bi'

const ImagePreview = ({ visible, toggle, image }) => {
    return (
        <Mask
            visible={ visible }
            toggle={ toggle }>
            <div className="z-10 p-6 w-1/2">
                <ReactPanZoom
                    image={ image }
                    alt='Image alt text' />
                <span className="fixed bottom-5 right-10">
                    <a target="_blank" href={ image }>
                        <button className="p-0 text-white flex justify-center items-center font-extrabold w-16 h-16 bg-red-600 rounded-full hover:bg-red-700 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none">
                            <BiPrinter style={{ width: "1.5em", height: "1.5em" }} />
                        </button>
                    </a>
                </span>
            </div>
        </Mask>
    )
}

export default ImagePreview